import React, {useEffect, useState} from "react";
import "./credit-transactions-history.scss"
import customAxios from "../../../../../service/api/interceptors";
import moment from "moment";
import {CustomLoader} from "../../../../../components/UI/CustomLoader/CustomLoader";
import {useHistory, useLocation} from "react-router-dom";
import {PlatformDateRangePicker} from "../../../../../components/UI/DateRangePicker/DateRangePicker";



type CreditTransactionType = {
    count: number
    datetime: number
    description: string
    id: number
    type: number
}

export const CreditTransactionsHistory: React.FC<{ companyId: number }> = ({ companyId }) => {
    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search);
    const [loading, setLoading] = useState(false)
    const [items, setItems] = useState<CreditTransactionType[]>([])
    const [count, setCount] = useState<number>(0)

    const start_date = searchParams.get("start_date") ? `&from_timestamp=${Number(searchParams.get("start_date")) / 1000}` : ``
    const end_date = searchParams.get("end_date") ? `&to_timestamp=${(Number(searchParams.get("end_date")) + 86400000) / 1000}` : ``

    const getData = async () => {
        setLoading(true)
        try {
            const { status, data } = await customAxios.get(`/company/${companyId}/credit/transaction-history?page=1${start_date}${end_date}`)
            if (status === 200) {
                setItems(data.credit_transactions)
                setCount(+data.count)
            }
        } catch (e) {}
        setLoading(false)
    }

    const updateParam = (paramName: string, newValue: string) => {
        if (searchParams.has(paramName)) {
            searchParams.set(paramName, newValue);
        } else {
            searchParams.append(paramName, newValue);
        }
        searchParams.set("page", '1')
        history.push(`${location.pathname}?${searchParams.toString()}`);
    }

    useEffect(() => {
        getData().then()
    }, [companyId, location])

    const updateDatePickerValue = (range: { startDate: Date | undefined, endDate: Date | undefined }) => {
        if (range.startDate === undefined) {
            searchParams.delete("start_date")
            searchParams.delete("end_date")
            history.push(`${window.location.pathname}?${searchParams.toString()}`);
            return
        }

        if (range.startDate && (moment(searchParams.get("start_date") || new Date()).format("DD-MM-YYYY") !== moment(range.startDate).format("DD-MM-YYYY"))) {
            updateParam("start_date", String(+range.startDate))
        }

        if (range.endDate && (moment(searchParams.get("end_date") || new Date()).format("DD-MM-YYYY") !== moment(range.endDate).format("DD-MM-YYYY"))) {
            updateParam("end_date", String(+range.endDate))
        }
    }

    return (
        <div className={"credit-transactions-history"}>
            <PlatformDateRangePicker
                className={"mr10"}
                label={"Date"}
                startDate={searchParams.has("start_date") ? new Date(Number(searchParams.get("start_date"))) : undefined}
                endDate={searchParams.has("end_date") ? new Date(Number(searchParams.get("end_date"))) : undefined}
                /*// @ts-ignore*/
                onChange={updateDatePickerValue}
            />
            {loading && <CustomLoader />}
            {!loading && <div>
                <div className="credit-transactions-history__table">
                    <div className="credit-transactions-history__table-header">
                        <div className="credit-transactions-history__table-header-item">Description</div>
                        <div className="credit-transactions-history__table-header-item">Date</div>
                        <div className="credit-transactions-history__table-header-item">Credits</div>
                    </div>
                </div>
                <div>
                    {
                        items.map(item => (
                            <CreditTransactionsHistoryItem
                                key={item.id}
                                item={item}
                            />
                        ))
                    }
                </div>
            </div>}
        </div>
    )
}

const CreditTransactionsHistoryItem: React.FC<{ item: CreditTransactionType }> = ({ item }) => {
    const isInc = +item.type === 0

    return (
        <div className={"credit-transactions-history__item"}>
            <div className="credit-transactions-history__item-td">
                <div className="credit-transactions-history__item-td-icon">
                    {isInc && <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="21" cy="21" r="21" fill="#DDFCE8"/>
                        <path d="M21 16L27.0622 23.5H14.9378L21 16Z" fill="#39C46A"/>
                    </svg>}
                    {!isInc && <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="21" cy="21" r="21" fill="#FCE0DD"/>
                        <path d="M21 26L14.9378 18.5L27.0622 18.5L21 26Z" fill="#FF351F"/>
                    </svg>
                    }
                </div>
                <span dangerouslySetInnerHTML={{ __html: item.description }} />
            </div>
            <div className="credit-transactions-history__item-td">
                {moment(+item.datetime * 1000).format("MMM DD, YYYY")}<br />
            </div>
            <div className="credit-transactions-history__item-td" style={{ color: isInc ? "#00AD45" : "#FF351F" }}>
                {isInc ? "+" : "-"}{item.count}
            </div>
        </div>
    )
}